import {Pipe, PipeTransform} from "@angular/core";
import {EXECUTION_STATUSES} from "../_maps/execution-statuses";

@Pipe({name: "executionStatus"})
export class ExecutionStatusPipe implements PipeTransform {
  transform(status: string): any {
    return status && EXECUTION_STATUSES[status] || 'не выполняется';
  }
}
